(() => {
  'use strict';
  if (window.__fiSmartExperience) return;
  window.__fiSmartExperience = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (v = '') => String(v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  function searchExperience() {
    const dialog = $('[data-fi-smart-search]');
    if (!dialog) return;
    const input = $('[data-fi-search-input]', dialog);
    const results = $('[data-fi-search-results]', dialog);
    const hint = $('[data-fi-search-hint]', dialog);
    const loader = $('[data-fi-search-loader]', dialog);
    const all = $('[data-fi-search-all]', dialog);
    let timer, controller, localIndex;
    const close = () => {
      dialog.close ? dialog.close() : dialog.removeAttribute('open');
      document.documentElement.style.removeProperty('overflow');
    };
    $$('[data-fi-smart-search-open]').forEach(b => b.addEventListener('click', () => {
      dialog.showModal ? dialog.showModal() : dialog.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => input.focus(), 30);
    }));
    $$('[data-fi-search-close]', dialog).forEach(b => b.addEventListener('click', close));
    dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
    const labels = {product:'Produkt',page:'Seite',article:'Beitrag',collection:'Kategorie',recipe:'Rezept',book:'Buch',faq:'FAQ'};
    const card = item => `<a class="fi-search-result" href="${esc(item.url)}"><span class="fi-search-result__media">${item.image ? `<img src="${esc(item.image)}" alt="" loading="lazy">` : esc(item.title[0])}</span><span class="fi-search-result__copy"><small class="fi-search-result__type">${labels[item.type] || 'Inhalt'}</small><span class="fi-search-result__title">${esc(item.title)}</span></span><span class="fi-search-result__arrow">→</span></a>`;
    async function getLocal() {
      if (localIndex) return localIndex;
      const html = await fetch('/').then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const data = [];
      $$('#rezepte article, #rezepte [data-recipe-card]', doc).forEach(el => {
        const title = $('h3,h4,[data-recipe-title]', el)?.textContent.trim();
        if (title) data.push({type:'recipe',title,url:'/#rezepte',image:$('img',el)?.src || ''});
      });
      $$('#FiBooks .fi-card', doc).forEach(el => {
        const title = $('h3',el)?.textContent.trim();
        if (title) data.push({type:'book',title,url:$('a',el)?.getAttribute('href') || '/#FiBooks',image:$('img',el)?.src || ''});
      });
      $$('[id*="FAQ"] details, .mgu-faq details', doc).forEach(el => {
        const title = $('summary',el)?.textContent.trim();
        if (title) data.push({type:'faq',title,url:'/#FAQ',image:''});
      });
      localIndex = data;
      return data;
    }
    async function run(q) {
      controller?.abort();
      controller = new AbortController();
      loader.classList.add('is-active');
      hint.textContent = 'Ergebnisse werden gesucht …';
      all.href = `/search?q=${encodeURIComponent(q)}`;
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product%2Ccollection%2Cpage%2Carticle&resources[limit]=6`;
        const [payload, local] = await Promise.all([
          fetch(url,{signal:controller.signal}).then(r => r.json()),
          getLocal().catch(() => [])
        ]);
        const groups = payload?.resources?.results || {};
        const remote = ['products','pages','articles','collections'].flatMap(key => (groups[key] || []).map(item => ({
          type:key.slice(0,-1),title:item.title,url:item.url,image:item.image || item.featured_image?.url || ''
        })));
        const needle = q.toLocaleLowerCase('de');
        const merged = [...remote,...local.filter(i => i.title.toLocaleLowerCase('de').includes(needle))]
          .filter((item,index,list) => index === list.findIndex(i => i.title === item.title && i.url === item.url)).slice(0,12);
        results.innerHTML = merged.length ? merged.map(card).join('') : '<div class="fi-smart-search__empty">Noch nichts Passendes gefunden. Probiere einen anderen Begriff.</div>';
        hint.textContent = `${merged.length} ${merged.length === 1 ? 'Ergebnis' : 'Ergebnisse'} gefunden`;
      } catch (e) {
        if (e.name !== 'AbortError') {
          results.innerHTML = '<div class="fi-smart-search__empty">Die Suche konnte gerade nicht geladen werden.</div>';
          hint.textContent = 'Suche vorübergehend nicht verfügbar';
        }
      } finally { loader.classList.remove('is-active'); }
    }
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        controller?.abort(); results.innerHTML = ''; hint.textContent = 'Tippe mindestens zwei Buchstaben ein.'; return;
      }
      timer = setTimeout(() => run(q),180);
    });
  }

  function cartToast() {
    const toast = $('[data-fi-cart-toast]');
    if (!toast) return;
    let timer;
    const hide = () => { toast.classList.remove('is-visible'); toast.setAttribute('aria-hidden','true'); };
    $$('[data-fi-cart-toast-close]',toast).forEach(b => b.addEventListener('click',hide));
    async function show(variantId) {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        const item = cart.items?.find(entry => String(entry.variant_id) === String(variantId)) || cart.items?.[0];
        if (!item) return;
        const image = $('[data-fi-cart-toast-image]',toast);
        image.src = item.image || ''; image.hidden = !item.image;
        $('[data-fi-cart-toast-title]',toast).textContent = item.product_title || item.title;
        $('[data-fi-cart-toast-variant]',toast).textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : `${cart.item_count} Artikel im Warenkorb`;
        $('[data-fi-cart-toast-price]',toast).textContent = new Intl.NumberFormat('de-DE',{style:'currency',currency:cart.currency || 'EUR'}).format(item.final_line_price/100);
        toast.classList.add('is-visible'); toast.setAttribute('aria-hidden','false');
        clearTimeout(timer); timer = setTimeout(hide,8500);
      } catch (_) {}
    }
    document.addEventListener('submit', e => {
      if (e.target.matches('form[action*="/cart/add"],form[data-type="add-to-cart-form"]')) {
        const variantId = new FormData(e.target).get('id');
        setTimeout(() => show(variantId),950);
      }
    },true);
  }

  function formFeedback() {
    $$('form[action*="/contact"]').forEach(form => {
      $$('input:not([type="hidden"]):not([type="submit"]):not([type="button"]),textarea,select',form).forEach(field => {
        const wrap = field.closest('.field,.form-field,.mgu-contact__field,.fi-newsletter-field') || field.parentElement;
        if (!wrap || $('.fi-field-feedback',wrap)) return;
        wrap.style.position = 'relative';
        const icon = document.createElement('span');
        icon.className = 'fi-field-feedback'; icon.setAttribute('aria-hidden','true'); wrap.append(icon);
        const validate = () => {
          if (!field.value.trim() && !field.required) {
            wrap.classList.remove('fi-field-valid','fi-field-invalid'); icon.textContent=''; return;
          }
          const valid = field.checkValidity();
          wrap.classList.toggle('fi-field-valid',valid); wrap.classList.toggle('fi-field-invalid',!valid);
          icon.textContent = valid ? '✓' : '!'; field.setAttribute('aria-invalid',String(!valid));
        };
        field.addEventListener('blur',validate);
        field.addEventListener('input',() => { if (field.value.trim() || wrap.classList.contains('fi-field-invalid')) validate(); });
      });
      form.addEventListener('submit',e => {
        if (form.checkValidity()) return;
        e.preventDefault(); $$('input,textarea,select',form).forEach(f => f.dispatchEvent(new Event('blur')));
        $(':invalid',form)?.focus();
      });
    });
  }

  function progress() {
    const host = $('[data-fi-scroll-progress]'), bar = $('span',host);
    if (!host || !/\/pages\/(uber-uns|ausbildung-1|mgu-brot-1|kurse-beratung)/.test(location.pathname)) return;
    host.classList.add('is-active');
    let busy = false;
    const update = () => {
      const max = document.documentElement.scrollHeight-innerHeight;
      bar.style.transform = `scaleX(${max > 0 ? Math.min(1,Math.max(0,scrollY/max)) : 0})`; busy=false;
    };
    addEventListener('scroll',() => { if (!busy) { busy=true; requestAnimationFrame(update); } },{passive:true});
    addEventListener('resize',update); update();
  }

  function transitions() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.body.classList.add('fi-page-enter');
    addEventListener('pageshow',() => document.body.classList.remove('fi-page-leaving'));
    document.addEventListener('click',e => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target || a.hasAttribute('download')) return;
      const url = new URL(a.href,location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || (url.pathname === location.pathname && url.search === location.search && url.hash)) return;
      e.preventDefault(); document.body.classList.add('fi-page-leaving'); setTimeout(() => location.href=url.href,205);
    });
  }

  const init = () => { searchExperience(); cartToast(); formFeedback(); progress(); transitions(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
